import { useMemo } from "react";
import { buildLookupColumns, filterLookupOptions, getLookupOptionValue } from "../utilities/tableHelpers";
import { buildAddConfig } from "../utilities/commerceConfig";
import { CommerceDimensionTable } from "../shared/CommerceDimensionTable";

export const DimRelationshipTable = ({
  relationship,
  config,
  rows,
  searchValue,
  onSearchChange,
  onRowClick,
  close
}) => {
  const lookupColumns = useMemo(
    () => buildLookupColumns(relationship),
    [relationship]
  );

  const lookupItems = useMemo(
    () =>
      filterLookupOptions(
        relationship,
        searchValue
      ),
    [relationship, searchValue]
  );

  const addConfig = useMemo(
    () =>
      buildAddConfig({
        entityConfig: config,
        relationship,
      }),
    [config, relationship]
  );

  return (
    <CommerceDimensionTable
      variant="lookup"
      title={relationship.label}
      columns={lookupColumns.map(
        (column) => column.label
      )}
      columnDefinitions={lookupColumns}
      data={lookupItems}
      getRowValues={(option) =>
        lookupColumns.map((column) =>
          getLookupOptionValue(
            option,
            column
          )
        )
      }
      onRowClick={(option) =>
        onRowClick(option, relationship)
      }
      searchValue={searchValue}
      searchPlaceholder={`Search ${relationship.label}...`}
      onSearchChange={onSearchChange}
      addButton
      addConfig={addConfig}
      close={close}
    />
  );
};
